import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact" style={{ padding: '0', marginTop: '0' }}>
        <div className="text-center">
          <a 
            href="mailto:david-haas1@gmx.de,juliushaas91@gmail.com?subject=[Kontaktanfrage Webseite]" 
            className="btn btn-custom"
            style={{ 
              fontSize: '18x',
              padding: '13px 26px', 
              minWidth: 'auto',
              width: 'auto',
              margin: '0'
            }}
          >
            Familie Haas kontaktieren
          </a>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
        </div>
      </div>
    </div>
  );
};